module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('ContentWrapper', {
    attrs: {
      "size": 100,
      "showContent": _vm.showContent
    }
  }, [_c('router-view'), _c('Sidebar')], 1), (_vm.isModalWindow) ? _c('ModalDefault', {
    attrs: {
      "header": _vm.modalHeader,
      "center": true,
      "grey": true,
      "text": _vm.modalText
    },
    on: {
      "close": _vm.closeModal
    }
  }, [(!_vm.isNoButtons) ? _c('template', {
    slot: "footer"
  }, [_c('ExtButton', {
    attrs: {
      "fill": _vm.isDefaultButtons,
      "size": "normal",
      "color": _vm.isSidebarButtons ? "red" : "green"
    },
    on: {
      "click": _vm.acceptModal
    }
  }, [_vm._v(_vm._s(_vm.acceptButtonText))]), _vm._v(" "), _c('ExtButton', {
    attrs: {
      "fill": _vm.isSidebarButtons,
      "size": "normal",
      "color": _vm.isSidebarButtons ? "green" : "red"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.declineButtonText))])], 1) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5139b1ec","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/Index.vue
// module id = 013ce498030c522ce301
// module chunks = 75